export default class TranslationItemModel {
  constructor(translate?: Partial<TranslationItemModel>) {
    if (translate) Object.assign(this, translate);
  }
  langCode: string;
  name: string;
  description: string;
}
